import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CurrencyManagementModel } from '../models/currency-management.model';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';

/**
 * Manages currencies
 */
@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  /**
   * Constructor
   * @param httpClient HttpClient
   */
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) { }

  /**
   * Loads the defined currencies for a valuation portfolio
   * @param valuationPortfolioId Valuation portfolio OID
   */
  loadDefinedCurrenciesForImport(valuationPortfolioId: number): Observable<CurrencyManagementModel[]> {
    const resource = this.appServiceHelper.getServiceEndpoint('pollux.currencies.api', 'currencies/rates');
    return this.httpClient.get<CurrencyManagementModel[]>(`${resource}/import/available?valuationPortfolioId=${valuationPortfolioId}`);
  }
}
